import { usePageContext } from 'application/contexts/PageContext';
import { JsonLdScript } from './JsonLdScript';

// Its own "heading" field (no pageHeader here). Listed items (newsPageWithTags) already get
// NewsArticle via ArticleJsonLd - this only covers the listing page itself.
type FilteredLibraryPageProperties = {
	heading?: string;
	description?: string;
};

// Rendered only via PageSchemaJsonLd's dispatch.
export const FilteredLibraryPageJsonLd: React.FC = () => {
	const pageContext = usePageContext();

	const properties = pageContext.content as unknown as FilteredLibraryPageProperties;
	const name = properties?.heading || pageContext.name;
	if (!name) return null;

	const data = {
		'@context': 'https://schema.org',
		'@type': 'CollectionPage',
		name,
		description: properties?.description || undefined,
		url: pageContext.path,
		inLanguage: pageContext.culture || undefined,
	};

	return <JsonLdScript id="filtered-library-page-jsonld" data={data} />;
};
